function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import { Layout, Avatar, Popover, Button } from '@nackle/paper';
const {
  Header
} = Layout;
import CompanySelect from '../company-select/company-select.js';
import './app-header.less';
class AppHeader extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "renderUserMenuTitle", () => {
      var _auth$state, _auth$state$claims, _auth$state2, _auth$state2$claims, _auth$state3, _auth$state3$claims;
      const {
        auth
      } = this.props;
      return /*#__PURE__*/React.createElement("div", {
        className: "app-header-profile"
      }, /*#__PURE__*/React.createElement(Avatar, {
        src: auth === null || auth === void 0 ? void 0 : (_auth$state = auth.state) === null || _auth$state === void 0 ? void 0 : (_auth$state$claims = _auth$state.claims) === null || _auth$state$claims === void 0 ? void 0 : _auth$state$claims.picture,
        size: 64
      }, this.getInitials()), /*#__PURE__*/React.createElement("span", {
        className: "name"
      }, auth === null || auth === void 0 ? void 0 : (_auth$state2 = auth.state) === null || _auth$state2 === void 0 ? void 0 : (_auth$state2$claims = _auth$state2.claims) === null || _auth$state2$claims === void 0 ? void 0 : _auth$state2$claims.name), /*#__PURE__*/React.createElement("span", {
        className: "username"
      }, auth === null || auth === void 0 ? void 0 : (_auth$state3 = auth.state) === null || _auth$state3 === void 0 ? void 0 : (_auth$state3$claims = _auth$state3.claims) === null || _auth$state3$claims === void 0 ? void 0 : _auth$state3$claims.username));
    });
    _defineProperty(this, "renderUserMenuContent", () => {
      const {
        auth
      } = this.props;
      return /*#__PURE__*/React.createElement("div", {
        className: "app-header-user-menu"
      }, /*#__PURE__*/React.createElement("div", {
        className: "action-container"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "primary",
        ghost: true,
        onClick: auth.signOut
      }, /*#__PURE__*/React.createElement("span", null, "Sign out"))));
    });
    _defineProperty(this, "getInitials", () => {
      var _auth$state4, _auth$state4$claims, _auth$state5, _auth$state5$claims;
      const {
        auth
      } = this.props;
      const firstName = ((auth === null || auth === void 0 ? void 0 : (_auth$state4 = auth.state) === null || _auth$state4 === void 0 ? void 0 : (_auth$state4$claims = _auth$state4.claims) === null || _auth$state4$claims === void 0 ? void 0 : _auth$state4$claims.given_name) || '')[0] || '';
      const lastName = ((auth === null || auth === void 0 ? void 0 : (_auth$state5 = auth.state) === null || _auth$state5 === void 0 ? void 0 : (_auth$state5$claims = _auth$state5.claims) === null || _auth$state5$claims === void 0 ? void 0 : _auth$state5$claims.family_name) || '')[0] || '';
      return `${firstName}${lastName}`;
    });
  }
  render() {
    var _auth$state6, _auth$state6$claims;
    const {
      auth,
      companyId,
      onCompanyChange,
      companySelectDisabled
    } = this.props;
    return /*#__PURE__*/React.createElement(Header, {
      className: "app-header"
    }, /*#__PURE__*/React.createElement(CompanySelect, {
      auth: auth,
      companyId: companyId,
      onChange: company => {
        if (typeof onCompanyChange === 'function') {
          onCompanyChange(company);
        }
      },
      companySelectDisabled: companySelectDisabled
    }), /*#__PURE__*/React.createElement("div", {
      className: "menu-bar"
    }, /*#__PURE__*/React.createElement(Popover, {
      trigger: "click",
      placement: "bottomRight",
      title: this.renderUserMenuTitle(),
      content: this.renderUserMenuContent()
    }, /*#__PURE__*/React.createElement(Avatar, {
      className: "app-header-avatar",
      src: auth === null || auth === void 0 ? void 0 : (_auth$state6 = auth.state) === null || _auth$state6 === void 0 ? void 0 : (_auth$state6$claims = _auth$state6.claims) === null || _auth$state6$claims === void 0 ? void 0 : _auth$state6$claims.picture
    }, this.getInitials()))));
  }
}
export default AppHeader;
//# sourceMappingURL=app-header.js.map